import {
  OpenAPI,
  PurchaseOrderLineRead,
  PurchaseOrderSearchFields,
  PurchaseOrderService,
} from "../api/generated"

OpenAPI.BASE = import.meta.env.VITE_API_ENDPOINT

export async function getPurchaseOrders() {
  const data = PurchaseOrderService.getAllPurchaseOrdersPurchaseOrdersAllGet()
  return data
}

export async function searchPurchaseOrders(searchString: string,opco:string) {
  const data = PurchaseOrderService.searchPurchaseOrdersPurchaseOrdersSearchGet(
    PurchaseOrderSearchFields.PURCHASE_ORDER_NUMBER,
    searchString,
    opco
  )
  return data
}

export async function getPurchaseOrderDetail(purchaseOrderId: number) {
  const data =
    PurchaseOrderService.getAdditionalPoLinesPurchaseOrdersIdUnmatchedLinesGet(
      purchaseOrderId,
    )
  return data
}
